import { Model } from '@vuex-orm/core';

export default class Levelable extends Model {
  static entity = 'levelables';

  static fields() {
    return {
      id: this.uid(),
      level_id: this.attr(null),
      levelable_id: this.attr(null),
      levelable_type: this.attr(null),
    };
  }
}
